import { Component, Input, ViewEncapsulation, Output, ElementRef, EventEmitter, OnInit } from '@angular/core';

@Component({
  selector: 'nbx-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.scss'],
  encapsulation: ViewEncapsulation.ShadowDom
})
export class SliderComponent implements OnInit {
  @Input() min = 1000;
  @Input() max = 2000;
  @Input() step = 100;
  @Input() color = "#ff7f32";
  @Input() value = this.min;
  @Input() markers: string =  '5,13,19';
  @Input() highlight: string = "#00aa13";
  @Output() getval = new EventEmitter()
  @Input() prefix = '';
  valid
  markpoints;
  number;

  constructor(public element: ElementRef) {}

  ngOnInit() {
    this.markpoints = this.markers.split(',');

    this.element
    .nativeElement
    .style.setProperty('--slider-color', this.color);

    if (this.markpoints.includes(this.value))
    {
      this.element.nativeElement.style.setProperty('--thumb-color', this.highlight);
    }
    else {
      this.element
      .nativeElement
      .style.setProperty('--thumb-color', this.color);
    }

  }

  parse(val) {
    // console.log("Val entered: ", val);
    // console.log(parseFloat(val.replace(/,/g, '')));
    return parseFloat(val.replace(/,/g, ''));
  }

  onChange(val) {
    val = parseFloat(val.replace(/,/g, ''));
    // console.log(type);
    // console.log(typeof val); //reverse the transform if val has a ','

    if (val > this.max)
    {
      // console.log('more than max');
      this.value = this.max;
    }
    else if (val < this.min)
    {
      // console.log('less than min');
      this.value = this.min;
    }
    else if (val % this.step != 0)
    {
      // console.log('modulo not 0');
      var rounded = Math.round(val / this.step) * this.step;
      // console.log('round: ', rounded);
      this.value = rounded;
    }
    else{
      this.value = val;
    }
    this.getval.emit(this.value);
    return this.transform(this.value.toString());
  }

  emphasize(val) {
    if (this.markpoints.includes(val)) 
    {
      this.element
    .nativeElement
    .style.setProperty('--thumb-color', this.highlight);
    }
    else {
      {
        this.element
      .nativeElement
      .style.setProperty('--thumb-color', this.color);
      }
    }

  }

  RangeValue = 0;

  startEnd = [
    this.min,
    this.max,
  ]

  saverange(NewVal) {
    this.RangeValue = NewVal;
  }

  transform(val) {
    // console.log(val);
    if(val){
    val = this.format_number(val.toString(), '');
    }
    return val;
  }
  
  format_number(number, prefix) {
    // console.log(number)
    let thousand_separator = ',',
      decimal_separator = '.',
      regex = new RegExp('[^' + decimal_separator + '\\d]', 'g'),
      number_string = number.replace(regex, '').toString(),
      split = number_string.split(decimal_separator),
      rest = split[0].length % 3,
      result = split[0].substr(0, rest),
      thousands = split[0].substr(rest).match(/\d{3}/g);

    if (thousands) {
      let separator = rest ? thousand_separator : '';
      result += separator + thousands.join(thousand_separator);
    }
    result = split[1] != undefined ? result + decimal_separator + split[1] : result;
    return prefix == undefined ? result : (result ? prefix + result : '');
  };

}
